import {defineMessages} from 'react-intl'

export default defineMessages({
  requiredField: {
    id: 'requiredField',
    defaultMessage: 'This is a required Field'
  },
  emptyFirstName: {
    id: 'emptyFirstName',
    defaultMessage: 'Please enter your first name'
  },
  emptyLastName: {
    id: 'emptyLastName',
    defaultMessage: 'Please enter your last name'
  },
  invalidNonLatinCharacters: {
    id: 'invalidNonLatinCharacters',
    defaultMessage: 'Please use Latin characters only (A-Z, a-z, 0-9)'
  },
  invalidPhoneNumber: {
    id: 'invalidPhoneNumber',
    defaultMessage: 'Insert a valid phone number'
  },
  invalidPhoneNumberB: {
    id: 'invalidPhoneNumberB',
    defaultMessage:
      "This doesn't look like a real phone number. You can only use numbers, dashes, and spaces"
  },
  emptyPhoneNumber: {
    id: 'emptyPhoneNumber',
    defaultMessage: 'Please enter your phone number'
  },
  invalidEmailAddress: {
    id: 'invalidEmailAddress',
    defaultMessage: 'Insert a valid email address'
  },
  invalidEmailAddressB: {
    id: 'invalidEmailAddressB',
    defaultMessage:
      "This isn't a correct email format. Please check and try again"
  },
  emptyEmailAddress: {
    id: 'emptyEmailAddress',
    defaultMessage: 'Please enter your email address'
  },
  emptyCity: {
    id: 'emptyCity',
    defaultMessage: 'Please enter your city'
  },
  invalidCreditCard: {
    id: 'invalidCreditCard',
    defaultMessage: 'Insert a valid card number'
  },
  invalidCreditCardCVV: {
    id: 'invalidCreditCardCVV',
    defaultMessage: 'Insert a valid CVV'
  },
  emptyCreditCardSecurityCode: {
    id: 'emptyCreditCardSecurityCode',
    defaultMessage: 'Please enter a valid security code'
  },
  invalidCreditCardSecurityCodeAMX: {
    id: 'invalidCreditCardSecurityCodeAMX',
    defaultMessage: `Please enter a valid security code<break></break>
    • Enter the 4 numbers on the front of your card`
  },
  invalidCreditCardSecurityCodeOthers: {
    id: 'invalidCreditCardSecurityCodeOthers',
    defaultMessage: `Please enter a valid security code<break></break>
    • Enter the 3 numbers on the back of your card`
  },
  invalidCreditCardSecurityCodeUnknown: {
    id: 'invalidCreditCardSecurityCodeUnknown',
    defaultMessage: `Please enter a valid security code<break></break>
    • Enter the 3 numbers on the back of your card<break></break>
    • Enter the 4 numbers on the front of your card (Amex)`
  },
  invalidCardExpirationB: {
    id: 'invalidCardExpirationB',
    defaultMessage: 'Please enter a month and a year in the future (MM/YY)'
  },
  emptyCardExpiration: {
    id: 'emptyCardExpiration',
    defaultMessage: 'Please enter a valid date'
  },
  invalidPassword: {
    id: 'invalidPassword',
    defaultMessage: 'Insert a valid password'
  },
  invalidCreditCardType: {
    id: 'invalidCreditCardType',
    defaultMessage: 'This card type is not accepted'
  },
  emptyCreditCard: {
    id: 'emptyCreditCard',
    defaultMessage: 'Please enter a valid card number'
  },
  emptyAddressLine1: {
    id: 'emptyAddressLine1',
    defaultMessage: 'Please enter your street and number'
  },
  emptyPostalCode: {
    id: 'emptyPostalCode',
    defaultMessage: 'Please enter your postal code'
  },
  invalidPostalCode: {
    id: 'invalidPostalCode',
    defaultMessage:
      "This doesn't look like a valid postal code. You can only use letters, numbers and dashes"
  },
  invalidCreditCardholdersname: {
    id: 'invalidCreditCardholdersname',
    defaultMessage:
      'Please enter your cardholder name as it appears on your card'
  },
  addressNotFound: {
    id: 'addressNotFound',
    defaultMessage: 'Sorry, we could not find this address'
  }
})
